/** 复制模板时名称追加「-副本」，并保证不超过 maxLen。 */
export function copyTemplateName(name, maxLen = 128) {
  const base = String(name || '').trim() || '未命名模板';
  const suffix = '-副本';
  if (base.length + suffix.length <= maxLen) return `${base}${suffix}`;
  const keep = Math.max(0, maxLen - suffix.length);
  return `${base.slice(0, keep)}${suffix}`;
}
